import { createFileRoute } from '@tanstack/react-router'

import { FrictionSettingsPage } from '#features/settings/friction/friction-settings-page'

export const Route = createFileRoute('/_app/$workspace/settings/friction')({
  head: () => ({
    meta: [
      {
        title: 'Friction settings',
      },
    ],
  }),
  component: () => <FrictionSettingsPage />,
})
